import Tag from 'components/new-ui/base/tag/Tag';
import { IndividualType } from 'store/individuals/individual';
import { individualTypeText } from 'views/user-management/utils';

type Props = {
    role: IndividualType;
};

const TeamMemberTag = ({ role }: Props) => {
    const roleName = individualTypeText[role];

    switch (role) {
        case IndividualType.TEAM_MANAGER: {
            return <Tag label={roleName} status="processing" />;
        }

        case IndividualType.JOB_MANAGER: {
            return <Tag label={roleName} status="warning" />;
        }

        case IndividualType.CLEARANCE_AGENT: {
            return <Tag label={roleName} status="success" />;
        }

        default: {
            return <Tag label={roleName} status="default" />;
        }
    }
};

export default TeamMemberTag;
